export default "/images/codesandbox.svg?d3edcb5a6d27e4056b299469f386a7bb";